import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { camelCaseToTitleCase } from '../../Utilities/StringUtils';
import Button from '@mui/material/Button';
import { useContext, useEffect, useState } from 'react';
import SearchFiltersDialog from './SearchFiltersDialog';
import DropDownViewModel from '../../Utilities/ViewModels/DropDownViewModel';
import { APIContext } from '../../Contexts/APIContext';
import { OrganisationsContext } from '../../Contexts/OrganisationsContext';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import SaveFiltersDialog from './SaveFiltersDialog';

export default function OrgFilterBar() {
    const { get } = useContext(APIContext);
    const { filterState, updateFilterState } = useContext(OrganisationsContext);
    const [open, setOpen] = useState(false);
    const [savedQueries, setSavedQueries] = useState<DropDownViewModel[]>([]);
    const [queryId, setQueryId] = useState<string | null>(null);
    const [openSave, setOpenSave] = useState(false);

    const closeDialog = () => {
        setOpen(false);
    };

    const getActiveFiltersAsTitleCase = () => {
        return Object.entries(filterState)
            .filter(([_, value]) => value)
            .map(([key]) => key)
            .filter(f => f !== 'pageNumber' && f !== 'rowsPerPage' && f !== 'order' && f !== 'orderBy' && f !== 'orderByProp' && f !== 'quickSearch');
    };

    const [dropdowns, setDropdowns] = useState<Record<string, DropDownViewModel[]>>({
        licenseType: [],
        invoicePayments: [],
        invoicePayMethod: [],
        invoiceNotice: [],
        estimateNotice: [],
    });

    useEffect(() => {
        getDropDowns();
        getQueries();
    }, []);

    const getDropDowns = async () => {
        const endpoints = {
            licenseType: 'GetLicenseTypeDropdown',
            invoicePayments: 'GetInvoicePayPeriodDropdown',
            invoicePayMethod: 'GetInvoicePayMethodDropdown',
            invoiceNotice: 'GetInvoiceNoticeDropdown',
            estimateNotice: 'GetEstimateNoticeDropdown',
        };

        for (const [key, endpoint] of Object.entries(endpoints)) {
            get('Organisation', endpoint, (data: DropDownViewModel[]) =>
                setDropdowns((prev) => ({ ...prev, [key]: data }))
            );
        }
    }

    const getQueries = () => {
        get('OrganisationFilter', 'GetQueryDropdown', setSavedQueries);
    };

    useEffect(() => {
        if (queryId) {
            get('OrganisationFilter', `GetQuery?id=${queryId}`, updateFilterState);
        }
    }, [queryId]);

    const closeSaveDialog = (refresh: boolean) => {
        setOpenSave(false);

        if (refresh)
            getQueries();
    }

    return (
        <>
            <Grid container justifyContent="start">
                <Grid>
                    <Button variant="outlined" onClick={(openFilters) => setOpen(true)}>
                        Select Filters
                    </Button>
                </Grid>
                <Grid>
                    <TextField
                        sx={{ minWidth: 250 }}
                        size="small"
                        fullWidth
                        select
                        label="Saved Queries"
                        value={queryId}
                        onChange={(event) => setQueryId(event.target.value)}
                    >
                        {savedQueries.map((item, index) =>
                            <MenuItem key={'query' + index} value={item.id}>{item.label}</MenuItem>
                        )}
                    </TextField>
                </Grid>
                <Grid>
                    <Button variant="outlined" onClick={() => setOpenSave(true)}>
                        Save Query
                    </Button>
                </Grid>
                {getActiveFiltersAsTitleCase()
                    .map((filter) => {
                        const dropdownOptions = dropdowns[filter];
                        const selectedOption = dropdownOptions?.find(x => x.id === filterState[filter]);
                        const filterName = camelCaseToTitleCase(filter);

                        return (
                            <Grid key={filter}>
                                <Chip
                                    label={
                                        filter === 'active' || filter === 'administratorSitesOnly' ?
                                            camelCaseToTitleCase(filter)
                                            :
                                            selectedOption
                                                ? `${filterName} = ${selectedOption.label}`
                                                : `${filterName} = ${filterState[filter]}`
                                    }
                                    color="primary"
                                />
                            </Grid>
                        );
                    })}
            </Grid>
            <SearchFiltersDialog open={open} onClose={closeDialog} dropdowns={dropdowns} />
            <SaveFiltersDialog open={openSave} onClose={closeSaveDialog} />
        </>
    );
}
